import { word } from "@modules/core/utils/i18n"
import { ProfileLabelVisibility } from "@modules/profile/myProfile/components/profileLabelVisibility"
import { ProfileFormTabProps } from "@modules/profile/myProfile/profileFormikType"
import { FormikInput } from "@modules/ui/components/formikInput"
import { HUText } from "@modules/ui/components/huText"
import { HUStack } from "@modules/ui/components/layout"

export const AnatomyForm: React.FC<ProfileFormTabProps> = ({ isFormFieldInValid, getFormErrorMessage, formik }) => {
  return (
    <div className="flex flex-grow-1 flex-column justify-content-start mt-6 gap-4 px-4">
      <HUText fontStyle="TM" className="align-self-center mb-4">
        {word("profile.form.anatomy.title")}
      </HUText>

      {/* Height input */}
      <HUStack gap={6}>
        <ProfileLabelVisibility
          label={word("profile.form.height.label")}
          name="height"
          isInvalid={isFormFieldInValid("height")}
          displayVisibleToggle
          visibility={formik.getFieldProps("heightVisibility").value}
          onToggleVisibility={() =>
            formik.setFieldValue("heightVisibility", !formik.getFieldProps("heightVisibility").value)
          }
        />
        <FormikInput
          type="number"
          numberProps={{ className: "flex-1" }}
          getFieldProps={formik.getFieldProps}
          setFieldValue={formik.setFieldValue}
          isInvalid={isFormFieldInValid("height")}
          name="height"
          error={getFormErrorMessage("height")}
          rightButton={<div style={{ width: 20 }}>cm</div>}
        />
      </HUStack>

      {/* Weight input */}
      <HUStack gap={6}>
        <ProfileLabelVisibility
          label={word("profile.form.weight.label")}
          name="weight"
          isInvalid={isFormFieldInValid("weight")}
          displayVisibleToggle
          visibility={formik.getFieldProps("weightVisibility").value}
          onToggleVisibility={() =>
            formik.setFieldValue("weightVisibility", !formik.getFieldProps("weightVisibility").value)
          }
        />
        <FormikInput
          type="number"
          numberProps={{ className: "flex-1" }}
          setFieldValue={formik.setFieldValue}
          getFieldProps={formik.getFieldProps}
          isInvalid={isFormFieldInValid("weight")}
          name="weight"
          error={getFormErrorMessage("weight")}
          rightButton={<div style={{ width: 20 }}>kg</div>}
        />
      </HUStack>
    </div>
  )
}
